import styled from '@emotion/styled'

export const HStack = styled.div`
  display: flex;
  justify-content: space-between;
`
